import { Tabs } from 'antd';
import React from 'react';

import SignInProfessor from './SignInProfesor';
import SignInAdmin from './SignInAdmin';
import SignInStudent from './SignInStudent';
import SignInColegio from './SignInColegio';
import SignInMonitor from './SignInMonitor';

const TabPane = Tabs.TabPane;

const SignInTabs = () => {
	return (
		<Tabs defaultActiveKey="1">
			<TabPane tab="Estudiantes" key="1">
				<SignInStudent />
			</TabPane>
			<TabPane tab="Profesores" key="2">
				<SignInProfessor />
			</TabPane>
			<TabPane tab="Colegios" key="3">
				<SignInColegio />
			</TabPane>
			<TabPane tab="Monitores" key="4">
				<SignInMonitor />
			</TabPane>
			<TabPane tab="Administradores" key="5">
				<SignInAdmin />
			</TabPane>
		</Tabs>
	);
};

const MemoizedSignInTabs = React.memo(SignInTabs);

export default MemoizedSignInTabs;
